const APP_LOGO = {
  circularLogo: require("./images/logo.png"),
  appLogo: require("./images/logo.png"),
};

const APP_ICONS = {
  dashboardIconWhite: require("./icons/dashboard-icon-white.png"),
  dashboardIconBlack: require("./icons/dashboard-icon-black.png"),
  homeIconWhite: require("./icons/home-icon-white.png"),
  homeIconBlack: require("./icons/home-icon-black.png"),
  userIconWhite: require("./icons/user-icon-white.png"),
  userIconBlack: require("./icons/user-icon-black.png"),
  cashIconWhite: require("./icons/cash-icon-white.png"),
  cashIconBlack: require("./icons/cash-icon-black.png"),
  timerIconWhite: require("./icons/timer-icon-white.png"),
  timerIconBlack: require("./icons/timer-icon-black.png"),
  bellIconBlue: require("./icons/bell-icon-blue.png"),
  bellBgIconBlue: require("./icons/bell-bg-icon-blue.png"),
  userBgIcon: require("./icons/user-bg-icon.png"),
  homeBgIcon: require("./icons/home-bg-icon.png"),
  timerBgIcon: require("./icons/timer-bg-icon.png"),
  cashBgIcon: require("./icons/cash-bg-icon.png"),
  balanceBgIcon: require("./icons/balance-bg-icon.png"),
  cashHandBgIcon: require("./icons/cash-hand-bg-icon.png"),
  profitBgIconGreen: require("./icons/profit-bg-icon-green.png"),
  profitBgIconBlue: require("./icons/profit-bg-icon-blue.png"),
  searhIcon: require("./icons/search-icon.png"),
  ellipsisIcon: require("./icons/ellipsis-icon.png"),
  arrowUpwordIconGreen: require("./icons/arrow-upword-icon-green.png"),
  warningIcon: require("./icons/warning-icon.png"),
  editIconBlue: require("./icons/edit-icon-blue.png"),
  walletBgIcon: require("./icons/wallet-bg-icon.png"),
  fileSaveIconBlue: require("./icons/file-save-icon-blue.png"),
  questionIcon: require("./icons/question-circle-icon.png"),
  logoutIconWhite: require("./icons/logout-icon-white.png"),
  chevronLeftIcon: require("./icons/chevron-left-ico.png"),
  chevronRightIcon: require("./icons/chevron-right-ico.png"),
  exportGreyIcon: require("./icons/export-icon.png"),
  handshakeIcon: require("./icons/handshake-inactive-icon.png"),
};

const APP_IMAGES = {
  dumyUserImg: require("./images/dumy-user-img.png"),
  storeImg: require("./images/store-img.png"),
  storeImg1: require("./images/store-img-1.png"),
};

export { APP_LOGO, APP_ICONS, APP_IMAGES };
